<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container w-min-800">
          <div class="modal-header">
            <slot name="header"> New Pots </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
              <div class="row">
                <div class="col-2">
                  <label for="plant_variety"> Size in CM </label>
                </div>
                <div class="col-9">
                  <input
                    type="text"
                    class="form-control"
                    id="new_plant_variety"
                    ref="plant_variety"
                    placeholder=" Enter plant variety common name"
                    v-modal="password"
                  />
                </div>
              </div>

              <div class="row">
                <div class="col-2">
                  <label for="plant_variety"> Botanical Name: </label>
                </div>
                <div class="col-9">
                  <input
                    type="text"
                    class="form-control"
                    id="plant_botany"
                    ref="plant_botany"
                    placeholder="enter botanical name"
                    v-modal="position"
                  />
                </div>
              </div>

              <div class="row">
                <div class="col-2">
                  <label for="plant_variety"> Nursery Pot Sizes: </label>
                </div>
                <div class="col-9">
                  <input
                    type="text"
                    class="form-control"
                    id="plant_botany"
                    ref="plant_botany"
                    placeholder="enter botanical name"
                    v-modal="position"
                  />
                </div>
              </div>

            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button class="btn btn-plt" @click="_save">
                Save &amp; Close
              </button>
              <button class="btn btn-plt" @click="$emit('close')">
                Cancel
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "CreatePots",
  
  data: () => ({
    new_password: "",
    confirm_password: "",
  }),

  props: {
    personnel: {
      type: Object,
      default: null,
    },
  },

  methods: {
    ...mapActions("personnels", ["apiCreatePassword"]), //personnels.js
    //...mapActions("inventory", ["apiCreatePassword"]),

    _save() {
      if (!this.$refs.plant_variety.value) {
        alert("please enter a plant variety"); // todo - place the correct references
        return;
      }

      // TODO - 
      var password = {
        id: this.personnel.id,
        new_password: this.$refs.personnel_new_password.value,
        confirm_password: this.$refs.personnel_confirm_password.value,
      };

      this.apiCreatePassword(password);
      this.$emit("close");
    },

    // TODO - 
    getPassword() {
      if (this.personnel == null) {
        return "";
      } else {
        return this.personnel_new_password;
      }
    },

    clear() {
      this.new_password = "";
      this.confirm_password = "";
    },
  },

  components: {},
};
</script>
